// 用于项目Logo | 标题配置
export default {
  title: "校园集市", //项目标题
  logo: "/generated/logo-160.png", //项目logo设置
  logoHidden: true // logo组件是否隐藏设置
};
